module.exports = __webpack_public_path__ + "img/gb861_1.prt.d1b78851.jpg";